module.exports = __webpack_public_path__ + "static/media/patients_list_folder.9ee577c9.svg";